import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { ProductService } from '@modules/shared/services/product.service';
import { ProductActions } from '@store/actions/product.actions';
import { CreateProductRequest } from '@models/product.model';

@Injectable()
export class ProductEffects {
  private readonly actions$ = inject(Actions);
  private readonly productService = inject(ProductService);

  getProducts$ = createEffect(() => this.actions$.pipe(
      ofType(ProductActions.GET_PRODUCTS),
      exhaustMap(({payload}: { payload: string }) => this.productService.getAll(payload)
        .pipe(
          map(payload => ({type: ProductActions.GET_PRODUCTS_SUCCESS, payload})),
          catchError(error => of(({type: ProductActions.GET_PRODUCTS_FAILED, error}))),
        )),
    ),
  );

  updateProduct$ = createEffect(() => this.actions$.pipe(
      ofType(ProductActions.UPDATE_PRODUCT),
    exhaustMap(({webshopId, payload}: { webshopId: string, payload: any }) => {
      return this.productService.update(webshopId, payload)
        .pipe(
          map(payload => ({type: ProductActions.UPDATE_PRODUCT_SUCCESS, payload})),
          catchError(error => of(({type: ProductActions.UPDATE_PRODUCT_FAILED, error}))),
        )
    }),
    ),
  );

  createProduct$ = createEffect(() => this.actions$.pipe(
      ofType(ProductActions.CREATE_PRODUCT),
      exhaustMap(({webshopId, payload}: {
        webshopId: string,
        payload: CreateProductRequest
      }) => this.productService.create(webshopId, payload)
        .pipe(
          map(payload => ({type: ProductActions.CREATE_PRODUCT_SUCCESS, payload})),
          catchError(error => of(({type: ProductActions.CREATE_PRODUCT_FAILED, error}))),
        )),
    ),
  );

  deleteProduct$ = createEffect(() => this.actions$.pipe(
      ofType(ProductActions.DELETE_PRODUCT),
      exhaustMap(({webshopId, productId}: {
        webshopId: string, productId: string
      }) => this.productService.delete(webshopId, productId)
        .pipe(
          map(() => ({type: ProductActions.DELETE_PRODUCT_SUCCESS, payload: productId})),
          catchError(error => of(({type: ProductActions.DELETE_PRODUCT_FAILED, error}))),
        )),
    ),
  );
}
